import { render, staticRenderFns } from "./DmDownloadFormat.vue?vue&type=template&id=22597294&scoped=true&"
import script from "./DmDownloadFormat.vue?vue&type=script&lang=js&"
export * from "./DmDownloadFormat.vue?vue&type=script&lang=js&"
import style0 from "./DmDownloadFormat.vue?vue&type=style&index=0&id=22597294&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22597294",
  null
  
)

export default component.exports